import isEqual from 'react-fast-compare'
import { createSelectorCreator, lruMemoize } from 'reselect'

export const createResultEqualSelector = createSelectorCreator(lruMemoize, {
	resultEqualityCheck: isEqual,
})
